<template>
    <div>
        <AdminStickyHeader>
            <template #title>
                {{ titleText }}
                {{ this.entityName }}
            </template>
            <template #actions>
                <Loading v-if="loadingSaveData" class="mb-2" />
                <div class="form-group flex flex-wrap items-center gap-3">
                    <button
                        @click="saveData"
                        type="button"
                        class="btn btn-small btn-green"
                    >
                        {{ $t("admin.types.form.save") }}
                    </button>
                    <button
                        @click="cancel"
                        type="button"
                        class="btn btn-small btn-default"
                    >
                        {{ $t("admin.types.form.cancel") }}
                    </button>
                </div>
            </template>
        </AdminStickyHeader>

        <div>
            <div class="flex gap-4">
                <div class="w-1/2">
                    <div class="form-group">
                        <label for="name" class="font-bold"
                            >{{ $t("admin.types.form.name") }} *:</label
                        >
                        <div class="flex items-center">
                            <input id="name" type="text" v-model="form.name" />
                        </div>
                        <ValidationErrors :errors="errorsFor('name')" />
                    </div>

                    <div class="form-group">
                        <div class="flex items-center">
                            <label for="article_template" class="font-bold"
                                >{{
                                    $t("admin.types.form.article_template")
                                }}:</label
                            >
                        </div>

                        <div class="flex items-center">
                            <input
                                id="article_template"
                                type="text"
                                v-model="form.article_template"
                            />
                        </div>
                        <ValidationErrors
                            :errors="errorsFor('article_template')"
                        />
                    </div>

                    <div
                        class="form-group bg-lightblue-border"
                        v-if="!withoutImage"
                    >
                        <div class="flex items-center">
                            <label for="image" class="font-bold"
                                >{{ $t("admin.types.form.image") }}:
                            </label>
                        </div>

                        <FileInputBlock
                            :prefill="imagePreview"
                            :selectedImageFileNameDefault="
                                $t('main.image_not_selected')
                            "
                            :alreadyLoadText="$t('main.image_selected')"
                            :loadedFile="
                                this.type && this.type.data.attributes.image
                            "
                            @selected-file="(file) => selectFile(file, 'Image')"
                            @remove-file="removeFile('Image')"
                        >
                            <ValidationErrors :errors="errorsFor('image')" />
                        </FileInputBlock>
                    </div>
                </div>

                <div class="w-1/2">
                    <div class="form-group mb-4">
                        <label class="font-bold">Свойства: </label>
                        <div>
                            <button
                                class="rounded flex items-center focus:outline-none gap-2"
                                type="button"
                                @click="
                                    form.rotating = form.rotating == 1 ? 0 : 1
                                "
                            >
                                <span class="check"
                                    ><i
                                        v-if="form.rotating == 1"
                                        class="fas fa-check text-red-500"
                                    ></i
                                ></span>
                                <span class="text-sm">Может вращаться</span>
                            </button>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="font-bold mb-1">Класс объекта:</div>

                        <div class="flex items-center">
                            <input
                                type="radio"
                                id="moving_not"
                                :checked="form.moving == 'no'"
                                v-model="form.moving"
                                value="no"
                            />
                            <label
                                for="moving_not"
                                class="ml-2 text-sm"
                                v-html="'Не движимые'"
                            ></label>
                        </div>

                        <div class="flex items-center">
                            <input
                                type="radio"
                                id="moving_move"
                                :checked="form.moving == 'move'"
                                v-model="form.moving"
                                value="move"
                            />
                            <label for="moving_move" class="ml-2 text-sm"
                                >Движимые</label
                            >
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="name" class="font-bold"
                            >Уровень подъёма:</label
                        >
                        <div class="flex items-center gap-6">
                            <div class="w-16">
                                <input
                                    id="level"
                                    type="number"
                                    min="0"
                                    v-model="form.level"
                                    placeholder="0"
                                />
                            </div>

                            <div class="text-sm">0 - не поднимаются</div>
                        </div>
                    </div>

                    <div class="form-group mb-4">
                        <div>
                            <button
                                class="rounded flex items-center focus:outline-none gap-2"
                                type="button"
                                @click="
                                    form.not_install_up =
                                        form.not_install_up == 1 ? 0 : 1
                                "
                            >
                                <span class="check"
                                    ><i
                                        v-if="form.not_install_up == 1"
                                        class="fas fa-check text-red-500"
                                    ></i
                                ></span>
                                <span class="text-sm"
                                    >На данный Тип элементов ничего не
                                    устанавливается</span
                                >
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="admin-actions-panel mt-8">
                <div class="form-group flex flex-wrap items-center gap-3">
                    <button
                        @click="saveData"
                        type="button"
                        class="btn btn-small btn-green"
                    >
                        {{ $t("admin.types.form.save") }}
                    </button>
                    <button
                        @click="cancel"
                        type="button"
                        class="btn btn-small btn-default"
                    >
                        {{ $t("admin.types.form.cancel") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import validationErrors from "../../../mixins/validationErrors";
import AdminStickyHeader from "../StickyHeader.vue";
const defaultImagePreview = "/images/design/zaglushka-prevyu.svg";

const editRouteNames = new Set([
    "edit_element_type",
    "edit_engraving_type",
    "edit_landscaping_type",
]);

export default {
    name: "Form",
    components: { AdminStickyHeader },
    mixins: [validationErrors],
    props: {
        type: {
            type: Object,
        },
        withoutImage: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            titleMode: editRouteNames.has(String(this.$route?.name ?? ""))
                ? "edit"
                : "add",
            lockTitleMode: false,
            imagePreview: this.type
                ? this.type.data.attributes.image || defaultImagePreview
                : defaultImagePreview,
            loadingSaveData: false,
            elementGroups: [],
            form: {
                name: this.type ? this.type.data.attributes.name : "",
                article_template: this.type
                    ? this.type.data.attributes.article_template
                    : null,
                selectedImage: null,
                removeImage: null,
                level: this.type ? this.type.data.attributes.level : 0,
                rotating: this.type ? this.type.data.attributes.rotating : 0,
                not_install_up: this.type
                    ? this.type.data.attributes.not_install_up
                    : 0,
                moving: this.type ? this.type.data.attributes.moving : "no",
            },
        };
    },
    computed: {
        element_group() {
            return this.$store.state.elements.element_group;
        },
        titleText() {
            return this.titleMode === "edit"
                ? this.$t("admin.types.form.title_edit")
                : this.$t("admin.types.form.title_add");
        },
        entityName() {
            if (this.model == "App\\Models\\Material") return "Материал";
            if (this.model == "App\\Models\\Barrier") return "Ограда";
            if (this.model == "App\\Models\\Element")
                return (
                    this.element_group &&
                    this.element_group.data.attributes.name
                );
        },
        model() {
            return this.$store.state.types.currentModel;
        },
        group_id() {
            return this.$store.state.types.currentGroupId;
        },
        catalogElements() {
            return this.elementGroups.filter((eg) => eg.type == "element");
        },
        lanscapings() {
            return this.elementGroups.filter((eg) => eg.type == "landscaping");
        },
    },
    watch: {
        "$route.name": {
            immediate: false,
            handler(routeName) {
                if (this.lockTitleMode) return;
                this.titleMode = editRouteNames.has(String(routeName ?? ""))
                    ? "edit"
                    : "add";
            },
        },
    },
    methods: {
        getBackRouteName() {
            const routeName = String(this.$route?.name ?? "");
            if (
                routeName === "add_element_type" ||
                routeName === "edit_element_type"
            ) {
                return "elements_types";
            }
            if (
                routeName === "add_engraving_type" ||
                routeName === "edit_engraving_type"
            ) {
                return "engravings_types";
            }
            if (
                routeName === "add_landscaping_type" ||
                routeName === "edit_landscaping_type"
            ) {
                return "landscaping_types";
            }
            return null;
        },
        navigateBack() {
            const backRouteName = this.getBackRouteName();
            if (!backRouteName) return Promise.resolve();
            return this.$router
                .push({
                    name: backRouteName,
                    params: { ...this.$route.params },
                    query: { ...this.$route.query },
                })
                .catch(() => {});
        },
        cancel() {
            this.lockTitleMode = true;
            this.navigateBack().finally(() => {
                this.$store.dispatch("types/setAdd", null);
                this.$store.dispatch("types/setEdit", null);
                this.$store.commit("types/FETCH_TYPE", {});
            });
        },
        selectFile(file, dataProps) {
            this.form[`selected${dataProps}`] = file;
            this.form[`remove${dataProps}`] = false;
        },
        removeFile(dataProps) {
            this.form[`selected${dataProps}`] = null;
            this.form[`remove${dataProps}`] = true;
        },
        async saveData() {
            this.errors = null;
            this.loadingSaveData = true;
            try {
                let formDataPost = new FormData();

                if (this.type) formDataPost.append("_method", "PATCH");

                if (this.form.name !== null) {
                    formDataPost.append("name", this.form.name);
                }

                if (this.form.article_template !== null) {
                    formDataPost.append(
                        "article_template",
                        this.form.article_template
                    );
                }

                formDataPost.append("model", this.model);
                if (this.group_id) {
                    formDataPost.append("group_id", this.group_id);
                }

                if (this.form.selectedImage !== null) {
                    formDataPost.append("image", this.form.selectedImage);
                }

                if (this.form.removeImage) {
                    formDataPost.append("remove_image", this.form.removeImage);
                }

                formDataPost.append("rotating", +this.form.rotating);
                formDataPost.append("moving", this.form.moving);
                formDataPost.append("level", +this.form.level);
                formDataPost.append(
                    "not_install_up",
                    +this.form.not_install_up
                );

                let url = "/api/admin/types";
                if (this.type)
                    url = `/api/admin/types/${this.type.data.type_id}`;

                const res = (
                    await axios.post(url, formDataPost, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                ).data;

                this.$store.dispatch("types/setAdd", false);
                this.$store.dispatch("types/setEdit", null);
                this.$store.commit("types/FETCH_TYPE", {});

                const filterTypes = {
                    model: this.model,
                };
                if (this.group_id) {
                    filterTypes["group_id"] = this.group_id;
                }
                this.$store.dispatch("types/fetch", filterTypes);
                this.lockTitleMode = true;
                this.navigateBack();
            } catch (error) {
                this.errors = error.response && error.response.data.errors;
                this.status = error.response && error.response.status;
                if (error.response) {
                    const notification = {
                        type: "error",
                        message:
                            error.response &&
                            error.response.data &&
                            error.response.data.message,
                    };
                    this.$store.dispatch("notification/add", notification, {
                        root: true,
                    });
                }
            }
            this.loadingSaveData = false;
        },
    },
};
</script>
<style scoped>
.lift-on-object + .lift-on-object {
    margin-top: 15px;
}
.lift-on-object__title {
    margin-bottom: 7px;
}
.lift-on-object__lists {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: 10px;
    column-gap: 15px;
}
</style>
